import React, { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
import { baseUrl } from "../../Environments/environment";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";
import "react-datepicker/dist/react-datepicker.css";
import "./your-styles.css";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

import checkInI from "../../Assets/Checkin.svg";
import checkOutI from "../../Assets/Checkout.svg";
import { apiClient } from "../../api";
import { useSearchParams } from "react-router-dom";
import { ArrowRight, Reply } from "lucide-react";
import ReviewModal from "./ReviewModal";
import { CiCalendarDate } from "react-icons/ci";
import RepliesListModal from "./RepliesListModal";
import { DateRangePicker } from "@nextui-org/date-picker";
import { format } from "date-fns";

const mapStatus = {
	"All Bookings": "Reservation",
	"Check In": "Reservation",
	"All In House": "In House",
	"Check Out": "In House",
	"Checked Out": "Checked Out",
};

export default function Review() {
	const calendarRef = useRef(null);
	const [searchParams] = useSearchParams();
	const { selectedPropertyId } = useProperty();
	// const [guests, setGuests] = useState([]);
	const [guest, setGuest] = useState();
	const [reviews, setReviews] = useState();
	const [selectedReview, setSelectedReview] = useState(null);
	const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const [repliesListModal, setRepliesListModal] = useState(false);
	const [selectedRating, setSelectedRating] = useState("All");
	const [selectedPlatform, setSelectedPlatform] = useState("All");
	const [selectedTime, setSelectedTime] = useState("All");
	const [selectedDate, setSelectedDate] = useState(
		dayjs().format("YYYY-MM-DD"),
	);

	const ratings = [
		"All",
		"0 Star",
		"1 Star",
		"2 Star",
		"3 Star",
		"4 Star",
		"5 Star",
	];

	const platforms = ["All", "Onelyk", "Booking.com", "Airbnb"];

	const times = [
		"All",
		"Today",
		"Yesterday",
		"This Week",
		"This Month",
		"This Year",
	];

	async function fetchReviews() {
		try {
			setIsLoading(true);
			const token = localStorage.getItem("accessToken");
			const response = await apiClient.get(
				`${baseUrl}/review/${selectedPropertyId}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				},
			);
			console.log("Reviews :- ", response.data.result.reviews);
			setReviews(response.data.result.reviews);
			const filtered = response.data.result.reviews.reverse();
			setFilteredReviews(filtered);
		} catch (e) {
			console.error("Error Fetching Reviews :- ", e);
		} finally {
			setIsLoading(false);
		}
	}
	useEffect(() => {
		if (!selectedPropertyId) return;
		fetchReviews();
	}, [selectedPropertyId]);

	const getInitials = (firstName, lastName) => {
		return (firstName[0] + lastName[0]).toUpperCase();
	};

	const dropdownRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const [filteredReviews, setFilteredReviews] = useState([]);
	const [showPicker, setShowPicker] = useState(false);
	const [dateRange, setDateRange] = useState([
		{
			startDate: new Date(),
			endDate: new Date(),
			key: "selection",
		},
	]);

	const applyFilters = (rating, platform, time) => {
		if (!reviews) return;

		setIsLoading(true);
		setFilteredReviews([]);

		setTimeout(() => {
			let filtered = reviews;

			if (rating && rating !== "All") {
				const starNumber = parseInt(rating);
				filtered = filtered.filter(
					(review) => review.overAllRating === starNumber,
				);
			}

			if (platform && platform === "Onelyk") {
				filtered = filtered.filter(
					(review) => !review.platform || review.platform === platform,
				);
			} else if (platform && platform !== "All") {
				filtered = filtered.filter((review) => review.platform === platform);
			}

			if (time && time !== "All") {
				const now = new Date();
				filtered = filtered.filter((review) => {
					const reviewDate = new Date(review.createdAt);
					switch (time) {
						case "Today":
							return reviewDate.toDateString() === now.toDateString();
						case "Yesterday":
							const yesterday = new Date();
							yesterday.setDate(now.getDate() - 1);
							return reviewDate.toDateString() === yesterday.toDateString();
						case "This Week":
							const startOfWeek = new Date(now);
							startOfWeek.setDate(now.getDate() - now.getDay());
							return reviewDate >= startOfWeek && reviewDate <= now;
						case "This Month":
							return (
								reviewDate.getMonth() === now.getMonth() &&
								reviewDate.getFullYear() === now.getFullYear()
							);
						case "This Year":
							return reviewDate.getFullYear() === now.getFullYear();
						default:
							return true;
					}
				});
			}
			setFilteredReviews(filtered);
			setIsLoading(false);
		}, 500);
	};

	const handleRatingChange = (e) => {
		const selected = e.target.value;
		setSelectedRating(selected);
		applyFilters(selected, selectedPlatform, selectedTime);
	};

	const handlePlatformChange = (e) => {
		const selected = e.target.value;
		setSelectedPlatform(selected);
		applyFilters(selectedRating, selected, selectedTime);
	};

	const handleTimeChange = (e) => {
		const selected = e.target.value;
		setSelectedTime(selected);
		applyFilters(selectedRating, selectedPlatform, selected);
	};

	const handleSelect = (ranges) => {
		const selected = ranges.selection;
		if (selected?.startDate && selected?.endDate) {
			setDateRange([selected]);
			setShowPicker(false);
			// Optional callback
			// onDateRangeChange?.({ startDate: selected.startDate, endDate: selected.endDate });
		}
	};
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	return (
		<>
			{isLoading && <LoadingSpinner />}
			<div className="px-4 sm:px-6 lg:px-8">
				<div className="sm:flex sm:items-center mt-2">
					<div className="flex items-center justify-between w-full sm:flex-row">
						{/* Calendar on the left */}
						<div className="flex items-center">
							<div className="relative inline-block" ref={calendarRef}>
								<h1 className="text-base font-semibold text-gray-900 flex items-center space-x-2">
									<CiCalendarDate
										ref={calendarRef}
										className="text-gray-500 text-3xl cursor-pointer"
									/>
									<span>
										{selectedDate
											? dayjs(selectedDate).format("MM/DD")
											: dayjs().format("MM/DD")}
									</span>
								</h1>
							</div>
						</div>

						{/* Filter */}
						<div className="flex flex-col md:flex-row items-start md:items-center gap-4 mt-4">
							<select
								value={selectedTime}
								onChange={(e) => handleTimeChange(e)}
								className="border rounded-md px-4 py-2 text-sm text-gray-700 bg-white shadow-sm w-40"
							>
								{times.map((time) => (
									<option key={time} value={time}>
										{time}
									</option>
								))}
							</select>

							<select
								value={selectedPlatform}
								onChange={(e) => handlePlatformChange(e)}
								className="border rounded-md px-4 py-2 text-sm text-gray-700 bg-white shadow-sm w-40"
							>
								{platforms.map((platform) => (
									<option key={platform} value={platform}>
										{platform}
									</option>
								))}
							</select>

							<select
								value={selectedRating}
								onChange={(e) => handleRatingChange(e)}
								className="border rounded-md px-4 py-2 text-sm text-gray-700 bg-white shadow-sm w-40"
							>
								{ratings.map((rating) => (
									<option key={rating} value={rating}>
										{rating}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
				{/* Table of propeties diplay here */}
				<div className="mt-4 flow-root">
					{filteredReviews && filteredReviews.length > 0 ? (
						<div className="-mx-4 -my-2 max-h-screen overflow-x-auto sm:-mx-6 lg:-mx-6">
							<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
								<table className="min-w-full divide-y divide-gray-300">
									<thead>
										<tr className="bg-[#F9FAFB]">
											<th
												scope="col"
												className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
											>
												Name
											</th>
											<th
												scope="col"
												className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
											>
												Status
											</th>
											<th
												scope="col"
												className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
											>
												Check In/Out
											</th>

											<th
												scope="col"
												className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
											>
												Room Number
											</th>
											{/* <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Platform
                    </th> */}
											<th
												scope="col"
												className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
											>
												Comments
											</th>
											<th
												scope="col"
												className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
											>
												Rating
											</th>
											{/* <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Details</span>
                  </th> */}
										</tr>
									</thead>

									<tbody className="divide-y divide-gray-200 bg-white">
										{filteredReviews.map((review) => (
											<tr
												key={review.guestId._id}
												onClick={() => {
													setIsReviewModalOpen(true);
													setSelectedReview(review);
												}}
											>
												<td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
													<div className="flex items-center">
														<div className="h-10 w-10 flex-shrink-0 flex items-center justify-center rounded-full bg-[#6B7280] text-white font-medium">
															{getInitials(
																review.guestId.firstName,
																review.guestId.lastName,
															)}
														</div>
														<div className="ml-4">
															<div className="flex flex-col">
																<div className="font-medium text-gray-900">
																	{review.guestId.firstName +
																		" " +
																		review.guestId.lastName}
																</div>
															</div>
															<div class="block">
																<span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset text-gray-700 bg-gray-50 ring-gray-600/20">
																	{review.platform ? review.platform : "Onelyk"}
																</span>
															</div>
														</div>
													</div>
												</td>

												{/* Guest status */}
												<td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
													{review.guestStatus.currentStatus}
												</td>

												<td className="whitespace-nowrap px-3 py-5 space-y-1 text-sm text-gray-500">
													<div className="flex items-center space-x-2">
														<img
															src={checkInI}
															alt="Check-in"
															className="h-4 w-4"
														/>
														<p>
															{" "}
															{/* {formatDateWithLocalTimezone(guest.checkIn)} */}
															{new Date(review.guestId.checkIn).toLocaleString(
																"en",
																{
																	day: "2-digit",
																	month: "2-digit",
																	hour: "2-digit",
																	minute: "2-digit",
																	hour12: true,
																	timeZone: "UTC",
																},
															)}
														</p>
													</div>

													<div className="flex items-center space-x-2">
														<img
															src={checkOutI}
															alt="Check-out"
															className="h-3.5 w-3.5"
														/>
														<p>
															{" "}
															{/* {formatDateWithLocalTimezone(guest.checkOut)} */}
															{new Date(review.guestId.checkOut).toLocaleString(
																"en",
																{
																	day: "2-digit",
																	month: "2-digit",
																	hour: "2-digit",
																	minute: "2-digit",
																	hour12: true,

																	timeZone: "UTC",
																},
															)}
														</p>
													</div>
												</td>

												<td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
													{review.guestStatus.currentStatus == "In House" ||
													review.guestStatus.currentStatus == "Checked Out"
														? review.guestId.roomNumber
														: "N/A"}
												</td>
												<td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
													{/* {review.comments ? review.comments : "N/A1"} */}
													<div className="relative group w-fit max-w-[150px] cursor-pointer text-gray-500">
														<span className="truncate inline-block max-w-full">
															{review.comments?.length > 15
																? `${review.comments.slice(0, 15)}...`
																: review.comments || "N/A"}
														</span>

														{/* Tooltip only for long emails */}
														{review.comments?.length > 15 && (
															<div className="absolute left-0 top-full mt-1 w-max max-w-xs bg-gray-800 text-white text-xs rounded px-2 py-1 z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-normal shadow-lg break-all">
																{review.comments}
															</div>
														)}
													</div>
												</td>
												<td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-sm font-medium sm:pr-0">
													<div className="flex justify-between">
														<div className="flex flex-col space-y-2">
															<div
																className="flex items-center text-2xl"
																style={{ color: "#7B61FF" }}
															>
																{[...Array(5)].map((_, index) => (
																	<span key={index}>
																		{index < review.overAllRating ? "★" : "☆"}
																	</span>
																))}
															</div>
														</div>
													</div>
												</td>
												<td>
													<div className="flex justify-between">
														<div className="flex space-x-4">
															{/* Detailed Review Button */}
															<button
																className="text-red-600 hover:text-red-900 text-xl"
																onClick={(e) => {
																	e.stopPropagation();
																	setIsReviewModalOpen(true);
																	setSelectedReview(review);
																}}
															>
																<ArrowRight color="#7B61FF" />
															</button>
															<button
																className="text-red-600 hover:text-red-900 text-xl"
																onClick={(e) => {
																	e.stopPropagation();
																	setRepliesListModal(true);
																	setSelectedReview(review);
																}}
															>
																<Reply color="#7B61FF" />
															</button>
														</div>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					) : (
						<div className="text-center text-gray-500 mt-10 text-lg font-medium">
							No reviews found.
						</div>
					)}
				</div>

				{selectedReview && (
					<ReviewModal
						isOpen={isReviewModalOpen}
						onClose={() => setIsReviewModalOpen(false)}
						onCancel={() => setIsReviewModalOpen(false)}
						review={selectedReview}
					/>
				)}

				{repliesListModal && (
					<RepliesListModal
						onClose={() => setRepliesListModal(false)}
						review={selectedReview}
					/>
				)}
			</div>
		</>
	);
}
